import { useHistory } from 'react-router-dom';
import { IBulkUploadCard } from '../../../../../types/bulkUpload';
import BordOneToneIcon from '../../../../../components/NudosComponents/BordOneToneIcon/BordOneToneIcon';
import { NudosButton } from '../../../../../components/NudosComponents';
import { bordColorTheme } from 'styles/styles.constants';
import './BulkUploadCard.scss';

const BulkUploadCard = ({ title, description, icon, firstButton, secondButton }: IBulkUploadCard) => {
  const history = useHistory();
  return (
    <article className="bulkUploadCard">
      <span className="iconContainerHeader">
        <BordOneToneIcon variant={icon} stroke={bordColorTheme.navyBlue[900]} customWidth="24px" />
      </span>
      <h3 className="title">{title}</h3>
      <hr />
      <p className="description">{description}</p>
      <div className="actions">
        <NudosButton
          handleClick={() => history.push(firstButton.route)}
          buttonText={firstButton.text}
          colorPalette="secondary"
          buttonIcon={<BordOneToneIcon variant={firstButton.icon} stroke="black" customWidth="10px" />}
        />
        <NudosButton
          handleClick={() => history.push(secondButton.route)}
          buttonText={secondButton.text}
          buttonIcon={<BordOneToneIcon variant={secondButton.icon} stroke="white" customWidth="10px" />}
        />
      </div>
    </article>
  );
};

export default BulkUploadCard;
